import Hero from "../components/Hero";
import Manifesto from "../components/Manifesto";
import WorkGrid from "../components/WorkGrid";
import Contact from "../components/Contact";
import Footer from "../components/Footer";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <WorkGrid />
      <Manifesto />
      <Contact />
      <Footer />
    </main>
  );
}
